<template lang="pug">
.dot-process
  tabs(
    :tabs="TABS.map(i => i.name)"
    :index="tabIndex"
  )
  router-view
</template>

<script>
import Tabs from '@/components/Tabs'

const TABS = [
  {
    name: '社交监测类项目'
  },
  {
    name: '服务器类项目'
  }
]

export default {
  components: {
    Tabs
  },
  data () {
    return {
      TABS,
      tabIndex: 0
    }
  }
}
</script>

<style lang="stylus">
.dot-process
  position relative
  .campaign-tab
    margin 0 -32px
    #tab-服务器类项目
      color #c0c4cc
      cursor not-allowed
    .el-tabs__nav
      margin-left 32px
</style>
